import React from 'react';
import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import { setSelectedOperator } from 'flow/actions/SupervisorActions';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import {
    selectOperatorName,
    selectOperatorsSorted,
} from 'flow/selectors/operator-selectors';
import { selectSelectedOperator } from 'flow/selectors/SupervisorSelectors';
import { OperatorKey } from 'flow/types/EntityKeys';

const OperatorGroupDropdownMenu = () => {
    const { i18next } = useAppContext();

    const operatorKey = useAppSelector(selectSelectedOperator);

    const operatorName = useAppSelector((state) =>
        operatorKey === 'all'
            ? i18next.t('general.all')
            : selectOperatorName(state, operatorKey),
    );

    return (
        <Menu as="div" className="relative flex w-full text-left">
            {({ open }) => (
                <>
                    <MenuButton className="hover:darken-10 inline-flex w-full min-w-48 items-center justify-between rounded-sm bg-gray-200 px-3 py-2 text-sm font-bold text-gray-800">
                        {operatorName}
                        <Icon iconKey="arrow_down" />
                    </MenuButton>
                    {open ? <ComponentMenuItems /> : null}
                </>
            )}
        </Menu>
    );
};

export default OperatorGroupDropdownMenu;

const ComponentMenuItems = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const operators = useAppSelector(selectOperatorsSorted);

    const onItemClick = (key: 'all' | OperatorKey) => {
        dispatch(setSelectedOperator(key));
    };

    return (
        <MenuItems className="scrollbar shadow-base absolute end-0 z-20 mt-2 max-h-72 w-full origin-top-right rounded-md bg-white p-3 outline-gray-100 focus:outline">
            <MenuItem
                key={'mi-operator-all'}
                onClick={() => onItemClick('all')}
            >
                <span>{i18next.t('general.all')}</span>
            </MenuItem>
            {operators?.valueSeq().map((operator) => (
                <MenuItem
                    key={`mi-${operator.get('key')}`}
                    onClick={() => onItemClick(operator.get('key'))}
                >
                    <span>{operator.get('name')}</span>
                </MenuItem>
            ))}
        </MenuItems>
    );
};
